export const ACCEPTED_FILE_DOCUMENT_TYPES = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.tif,.png,.jpg,.svg,.csv,.gif,.xlsm,.twb,.twbx';